import { NgModule } from "@angular/core";
import { PaidPlanCardComponent } from "./paid-plan-card.component";
import { CommonModule } from "@angular/common";

@NgModule({
    imports: [CommonModule],
    declarations: [PaidPlanCardComponent],
    exports: [PaidPlanCardComponent]
})
export class PaidPlanCardModule {}